import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/PodcastForward.svg'

export const IconPodcastForward = IconSVG as IconComponent
